module.exports = __webpack_public_path__ + "static/img/summer.63134cd7.gif";